<!--
 * @Descripttion:
 * @version:
 * @Author: WANGCHUNYUAN
 * @Date: 2021-11-02 23:59:30
 * @LastEditTime: 2021-11-03 18:13:30
-->

<template>
  <div class="home" :style="setBg">
    <div class="logo">
      <img :src="logo" alt="" />
    </div>
    <div class="main-btn" @click="$router.push({ path: '/cata-h5' })"></div>
  </div>
</template>

<script>
import { fetchBg, fetchProject } from '@/api/sys'

export default {
  computed: {
    setBg() {
      return `background-image: url(${this.img})`
    }
  },
  data() {
    return {
      img: '',
      logo: '',
      url: ''
    }
  },
  methods: {
    async initProject() {
      const projectUrl = location.href.split('//')[1].split('/')[1]
      this.projectUrl = projectUrl
      const res = await fetchProject({ url: projectUrl })
      if (res.code == 200) {
        this.logo = res.data.logo
        this.img = res.data.phone_image
        this.id = res.data.id
      }
    },
    async loadBg() {
      const { data } = await fetchBg({ project_id: this.id, type: 1 })
      // this.url = data.phone_image
      this.img = data.phone_image
    }
  },
  async created() {
    await this.initProject()
    this.loadBg()
  }
}
</script>

<style lang="scss" scoped>
.home {
  position: relative;
  z-index: 1;
  width: 100%;
  height: 100%;
  background-repeat: no-repeat;
  background-size: 100% 100%;
  background-position: center;
  .logo {
    width: 62rem;
    height: 10.7rem;
    margin: 0 auto;
    padding-top: 15rem;
    img {
      width: 100%;
    }
  }
  .main-btn {
    position: absolute;
    z-index: 2;
    bottom: 17.5rem;
    left: 50%;
    transform: translateX(-50%);
    width: 35.3rem;
    height: 6.4rem;
    background: red;
    background: url('~@img/main-btn.png') no-repeat;
    background-size: 100% 100%;
    cursor: pointer;
  }
}
</style>
